<div class="component-container flex flex-col">
  <div class="heading mb-[0.5rem]">
    Audit History
  </div>
  <div class="sub-heading mb-[2rem]">
    {{item?.name}} (FG ID: {{item?.id}})
  </div>

  <div
    (scrolled)="onScroll()"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="10"
    [scrollWindow]="false"
    class="timeline-wrapper overflow-auto"
    infiniteScroll
  >
    <div *ngIf="!loading && auditList.length === 0"
         class="no-data flex flex-col justify-center items-center">
      <div class="text">No audit history found.</div>
    </div>

    <div class="timeline flex flex-col gap-[1.5rem]" *ngIf="auditList.length > 0">
      <div class="timeline-entry" *ngFor="let entry of auditList">
        <div class="flex flex-row items-center gap-[1rem] mb-[0.8rem] flex-wrap">
          <div class="action-badge"
               [ngStyle]="{'background-color': actionColors[entry.action]}">
            {{entry.action}}
          </div>
          <div class="audit-user font-poppins font-semibold text-[1.4rem]">
            {{entry.userName}}
          </div>
          <div class="audit-date text-[1.3rem]" style="color: #53565A;">
            {{entry.created_at | date:'MM/dd/YYYY hh:mm a'}}
          </div>
        </div>

        <div class="changes flex flex-col gap-[0.5rem]">
          <div class="change-row flex flex-row items-center gap-[1rem]"
               *ngFor="let change of getChangedFields(entry)">
            <div class="change-label font-semibold text-[1.3rem] min-w-[10rem]"
                 style="color: #373E46;">
              {{change.label}} :
            </div>
            <div class="flex flex-row items-center gap-[0.5rem] text-[1.3rem]">
              <span *ngIf="entry.action !== 'CREATE'" class="old-val">{{change.oldValue}}</span>
              <mat-icon *ngIf="entry.action !== 'CREATE'" class="arrow-icon">arrow_forward</mat-icon>
              <span class="new-val">{{change.newValue}}</span>
            </div>
          </div>
          <div *ngIf="entry.action === 'CREATE' && getChangedFields(entry).length === 0"
               class="text-[1.3rem]" style="color: #53565A;">
            Initial creation
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="loading"
         [ngClass]="{'initial': isFirstPage}"
         class="table-loader w-full flex justify-center items-center">
      <mat-spinner/>
    </div>
  </div>
</div>
